module.exports = __webpack_public_path__ + "static/media/course_bg.5e5b6a8c.svg";